import { Heading } from "@/components/ui/typography";

export default function TermsAndConditions() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <Heading size={"h1"} className="mb-6">
        Hypestream Terms and Conditions
      </Heading>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          SMS Service Agreement
        </Heading>
        <p>
          By providing your mobile number, you agree that HypeStream may send you periodic SMS or
          MMS messages containing but not limited to important information, updates, deals, and
          specials.
        </p>
      </section>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          Cancellation
        </Heading>
        <p>
          You can cancel the SMS service at any time. Just text "STOP" to the short code. After you
          send the SMS message "STOP" to us, we will send you an SMS message to confirm that you
          have been unsubscribed. After this, you will no longer receive SMS messages from us. If
          you want to join again, just sign up as you did the first time and we will start sending
          SMS messages to you again.
        </p>
      </section>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          Support
        </Heading>
        <p>
          If you are experiencing issues with the messaging program you can reply with the keyword
          HELP for more assistance, or you can get help directly at{" "}
          <a href="mailto:hypestream.io@gmail.com" className="underline">
            hypestream.io@gmail.com
          </a>
          .
        </p>
      </section>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          Carrier Liability
        </Heading>
        <p>Carriers are not liable for delayed or undelivered messages.</p>
      </section>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          Message and Data Rates
        </Heading>
        <p>
          As always, message and data rates may apply for any messages sent to you from us and to us
          from you. You will receive up to 4 messages a month. If you have any questions about your
          text plan or data plan, it is best to contact your wireless provider.
        </p>
      </section>

      <section className="mb-4">
        <Heading size={"h2"} className="font-bold mb-1">
          Privacy
        </Heading>
        <p>
          If you have any questions regarding privacy, please read our{" "}
          <a href="/legal/privacy" className="underline">
            privacy policy
          </a>
          .
        </p>
      </section>
    </div>
  );
}
